var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.405,
    height: 18.3,
    viewBox: "0 0 16.405 18.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:currentColor;stroke:currentColor;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.507,9.124V5.953a.466.466,0,1,0-.932,0v3.17a2.384,2.384,0,0,0,0,4.643V22.9a.466.466,0,1,0,.932,0V13.767a2.384,2.384,0,0,0,0-4.643Zm-.466,3.736a1.415,1.415,0,1,1,1.375-1.414A1.4,1.4,0,0,1,12.041,12.859Z",
    transform: "translate(-9.734 -5.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.909,14.323V5.479a.466.466,0,1,0-.932,0v8.843a2.384,2.384,0,0,0,0,4.642V22.52a.466.466,0,1,0,.932,0V18.965a2.384,2.384,0,0,0,0-4.643Zm-.466,3.736a1.415,1.415,0,1,1,1.375-1.414A1.4,1.4,0,0,1,40.443,18.058Z",
    transform: "translate(-32.39 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.311,10.069V5.479a.466.466,0,1,0-.932,0v4.59a2.384,2.384,0,0,0,0,4.643V22.52a.466.466,0,1,0,.932,0V14.712a2.384,2.384,0,0,0,0-4.643ZM68.845,13.8a1.415,1.415,0,1,1,1.375-1.414A1.4,1.4,0,0,1,68.845,13.8Z",
    transform: "translate(-55.047 -5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/Level.dba7472228f719cfa66bcf052bba1fb2.svg";
export { ForwardRef as ReactComponent };